var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-backtop',{attrs:{"bottom":100}},[_c('div',{staticStyle:{"{\n      height":"100%","width":"100%","background-color":"#f2f5f6","box-shadow":"0 0 6px rgba(0,0,0, .12)","text-align":"center","line-height":"40px","color":"var(--footer-color)","border-radius":"50%"}},[_c('i',{staticClass:"el-icon-arrow-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }